
<v-expand-transition>
    <div class="inb-entry-buttons">
        <div>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="inb-entry-button"
                        @click="onConfirm"
                    >
                        <v-icon small color="white">fas fa-check</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t("crm.entry.commit") }}</span>
            </v-tooltip>
        </div>

        <div>
            <v-tooltip left >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        depressed
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="inb-entry-button"
                        @click="onGotoIncident"
                    >
                        <v-icon small color="white">fas fa-arrow-left</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t ("crm.entry.goto") }}</span>
            </v-tooltip>
        </div>
    </div>

</v-expand-transition>
